import MonthsNames from '@/data/months-names.js';
import DaysNames from '@/data/days-names.js';

export default class CalendarUtils {
  /**
   * Returns first day visible in calendar "card"
   */
  static getStartDay (year, month) {
    let date = new Date(year, month - 1, 1, 12, 0, 0, 0);
    let dayNumber = date.getDay();

    if (dayNumber > 0) {
      date.setTime(date.getTime() - ((dayNumber - 1) * 24 * 60 * 60 * 1000));
    } else if (dayNumber === 0) {
      date.setTime(date.getTime() - (6 * 24 * 60 * 60 * 1000));
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns last day visible in calendar "card"
   */
  static getEndDay (year, month) {
    let dateTemp = new Date(year, month, 0, 12, 0, 0, 0);
    let date = new Date(year, month - 1, dateTemp.getDate(), 12, 0, 0, 0);
    let dayNumber = date.getDay();

    if (dayNumber > 0) {
      date.setTime(date.getTime() + ((7 - dayNumber) * 24 * 60 * 60 * 1000));
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns date since provided current date with given diff
   */
  static getDay (currentDate, diff) {
    let dateArray = currentDate.split('-').map(num => parseInt(num, 10));
    let newDate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2], 0, 0, 0, 0);
    newDate.setDate(newDate.getDate() + diff);

    return this.formatDateForPHP(newDate);
  }

  /**
   * Returns list of dates in a given period
   */
  static getDaysList (year, month) {
    let start = this.getStartDay(year, month);
    let end = this.getEndDay(year, month);
    let startArray = start.split('-').map(num => parseInt(num, 10));
    let endArray = end.split('-').map(num => parseInt(num, 10));
    let endDate = new Date(endArray[0], endArray[1] - 1, endArray[2], 0, 0, 0, 0);
    let today = new Date();
    let tempDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0);
    let days = [];

    while (tempDate.getTime() <= endDate.getTime()) {
      days.push({
        number: tempDate.getDate(),
        date: this.formatDateForPHP(tempDate),
        isCurrentMonth: tempDate.getMonth() + 1 === month,
        isToday: today.getFullYear() === tempDate.getFullYear() && today.getMonth() === tempDate.getMonth() && today.getDate() === tempDate.getDate()
      });
      tempDate.setDate(tempDate.getDate() + 1);
    }

    return days;
  }

  /**
   * Format JS Date object for use with PHP REST API
   */
  static formatDateForPHP (date) {
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(num => num < 10 ? '0' + num : num).join('-');
  }

  /**
   * Returns month name according to given month number
   */
  static getMonthName (monthNumber, short = false) {
    switch (monthNumber) {
      case 1: return short ? MonthsNames[0].short : MonthsNames[0].full;
      case 2: return short ? MonthsNames[1].short : MonthsNames[1].full;
      case 3: return short ? MonthsNames[2].short : MonthsNames[2].full;
      case 4: return short ? MonthsNames[3].short : MonthsNames[3].full;
      case 5: return short ? MonthsNames[4].short : MonthsNames[4].full;
      case 6: return short ? MonthsNames[5].short : MonthsNames[5].full;
      case 7: return short ? MonthsNames[6].short : MonthsNames[6].full;
      case 8: return short ? MonthsNames[7].short : MonthsNames[7].full;
      case 9: return short ? MonthsNames[8].short : MonthsNames[8].full;
      case 10: return short ? MonthsNames[9].short : MonthsNames[9].full;
      case 11: return short ? MonthsNames[10].short : MonthsNames[10].full;
      case 12: return short ? MonthsNames[11].short : MonthsNames[11].full;
      default: return short ? MonthsNames[0].short : MonthsNames[0].full;
    }
  }

  /**
   * Transform date to more human format
   */
  static humanDateFormat (date, showDayName = false, isShort = false) {
    if (!date) {
      return '-';
    }
    let dateToFormat = new Date(date);
    let day = dateToFormat.getDate();
    let month = dateToFormat.getMonth() + 1;
    let year = dateToFormat.getFullYear();

    if (showDayName) {
      let dayNumber = dateToFormat.getDay();
      let dayName = '';

      switch (dayNumber) {
        case 0: dayName = DaysNames.day7.full; break;
        case 1: dayName = DaysNames.day1.full; break;
        case 2: dayName = DaysNames.day2.full; break;
        case 3: dayName = DaysNames.day3.full; break;
        case 4: dayName = DaysNames.day4.full; break;
        case 5: dayName = DaysNames.day5.full; break;
        case 6: dayName = DaysNames.day6.full; break;
        default: dayName = DaysNames.day7.full; break;
      }

      if (!isShort) {
        dayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
      }

      return [dayName + ',', day, this.getMonthName(month, isShort), year].join(' ');
    }

    return [day, this.getMonthName(month, isShort), year].join(' ');
  }
  static prepareDateString (dateString, emptyValue = '-') {
    if (!dateString) {
      return emptyValue;
    }
    let dateFromString = new Date(dateString);

    return [
      dateFromString.getFullYear(),
      dateFromString.getMonth() + 1,
      dateFromString.getDate()
    ]
      .map(n => n < 10 ? '0' + n : n)
      .join('-');
  }
};
